var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardMsgWrap"},[_c('div',{staticClass:"cardTitle"},[_c('p',{staticClass:"name"},[_vm._v("【カジュアルアウター】柔らかく肌触りの良い綿素材を使用、軽い着心地、豊かな風合い")]),_c('span',{staticClass:"adCardMutiStatus"},[_vm._v("去逛逛")])]),_c('div',{staticClass:"cardMsg"},[_vm._v("5980")])])
}]

export { render, staticRenderFns }